import React, { useState, useEffect, useRef, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

import AppointmentCard from "../../components/appointmentcard/AppointmentCard";
import PatientAnswers from "../../components/patientanswers/PatientAnswers";
import Delete from "../../components/delete/Delete";
import "./Appointments.css";
import axios from "axios";
import moment from "moment";
import {
  isAndroid as android,
  isIOS as ios,
  osName as osname,
} from "react-device-detect";
import customProtocolCheck from "custom-protocol-check";
import { Context } from "../../context/Context";

const Appointments = (props) => {
  const navigate = useNavigate();
  const {appointments, setAppointments, contentAppointnentsLoaded, setContentAppointnentsLoaded} = useContext(Context);
  const [appointOpen, setOpenAppoint] = useState(-1);
  const [isOpenDelete, setOpenDelete] = useState(false);
  const [appointToDelete, setAppointToDelete] = useState(-1);
  const [desktopOpenLink, setDesktopOpenLink] = useState(false);
  const wrapperRef = useRef("");

  function useOutsideAppointmentAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpenAppoint(-1);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAppointmentAlerter(wrapperRef);

  // const launchAppointment = (appoint_id, event) => {
  //   event.stopPropagation();
  //   var uId = JSON.parse(localStorage.getItem("userData"))
  //     ? JSON.parse(localStorage.getItem("userData")).id
  //     : 0;
  //   var uToken = JSON.parse(localStorage.getItem("userData"))
  //     ? JSON.parse(localStorage.getItem("userData")).token
  //     : "";
  //   var openUrl =
  //     "virdiohealthapp://login?userId=" +
  //     uId +
  //     "&userToken=" +
  //     uToken +
  //     "#Intent;package=com.virdio.virdiohealthapp;scheme=open_app;end";
  //   if (android) {
  //     openUrl =
  //       "intent://virdio/?userId=" +
  //       uId +
  //       "&userToken=" +
  //       uToken +
  //       "#Intent;package=com.virdio.virdiohealth;scheme=open_app;end;";
  //   } else if (ios) {
  //     openUrl =
  //       "https://deeplink.virdiohealth.com/auth/?userId=" +
  //       uId +
  //       "&token=" +
  //       uToken;
  //   }
  //   if (desktopOpenLink) {
  //     window.open(
  //       osname === "Windows"
  //         ? "https://apps.microsoft.com/store/detail/virdiohealth/9MXKV20X29F7"
  //         : "https://apps.apple.com/app/virdio-heath-for-desktop/id6448693919"
  //     );
  //   } else {
  //     customProtocolCheck(
  //       openUrl,
  //       () => {
  //         setDesktopOpenLink(true);
  //       },
  //       () => {
  //         setDesktopOpenLink(false);
  //       },
  //       10000
  //     );
  //   }
  // };

  const launchAppointment = (appoint_id, event) => {
    event.stopPropagation();

    // grab user data
    const { id: uId = 0, token: uToken = "" } =
      JSON.parse(localStorage.getItem("userData")) || {};

    // build deep links
    const androidLink = `intent://virdio/?userId=${uId}&userToken=${uToken}#Intent;package=com.virdio.virdiohealth;scheme=open_app;end;`;
    const iosLink = `https://deeplink.virdiohealth.com/auth/?userId=${uId}&token=${uToken}`;
    const macLink = `virdiohealthapp://login?userId=${uId}&userToken=${uToken}`;

    // pick the right one
    const deepLink = android
      ? androidLink
      : ios
      ? iosLink
      : macLink;

    // try to open the protocol handler
    const start = Date.now();
    window.location.href = deepLink;

    // after 1.5s, if the protocol didn’t open, send them to the App Store
    setTimeout(() => {
      // if less than 100 ms elapsed it means the protocol wasn't handled
      if (Date.now() - start < 100) {
        const isMac = navigator.platform.toLowerCase().includes("mac");
        const fallbackURL = isMac
          ? "https://apps.apple.com/app/virdio-health-for-desktop/id6448693919"
          : "https://apps.microsoft.com/store/detail/virdiohealth/9MXKV20X29F7";
        window.open(fallbackURL, "_blank");
      }
    }, 1500);
  };

  useEffect(() => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    const eventSource = new EventSource(
      window.ajaxLink +
        "updatesse/events?observeData=updateCloudAppointments&valueName=" +
        userData.id.toString()
    );
    eventSource.onmessage = (e) => {
      if (e.data.toString().toLowerCase() === "update") {
        loadAppointments(userData);
      }
    };
    return () => {
      eventSource.close();
    };
    // eslint-disable-next-line
  }, []);

  const holdAppScroll = useRef(null);
  const appointRef = useRef({});
  const openSingleAppoint = (inx, e) => {
    /* e.stopPropagation(); */
    setOpenAppoint(inx);
    appointRef.current[inx].scrollIntoView();
    if (appointOpen === inx) {
      setOpenAppoint(-1);
      appointRef.current[inx].scrollIntoView();
    }
  };

  const handleKeyStroke = (e) => {
    if (
      e.keyCode &&
      (e.keyCode === 32 ||
        e.keyCode === 33 ||
        e.keyCode === 34 ||
        e.keyCode === 38 ||
        e.keyCode === 40)
    ) {
      setOpenAppoint(-1);
    }
  };

  const keyRef = useRef(handleKeyStroke);
  useEffect(() => {
    keyRef.current = handleKeyStroke;
  });
  useEffect(() => {
    const key = (e) => keyRef.current(e);
    window.addEventListener("keydown", key);
    return () => {
      window.removeEventListener("keydown", key);
    };
  }, []);

  const handleScrollApp = useCallback(() => {
    setOpenAppoint(-1);
  }, []);
  useEffect(() => {
    const scrl = holdAppScroll.current;
    scrl.addEventListener("mousewheel", handleScrollApp);

    return () => {
      scrl.removeEventListener("mousewheel", handleScrollApp);
    };
  }, [handleScrollApp]);

  const openCloseDelete = (item, event) => {
    event.stopPropagation();
    setOpenDelete(!isOpenDelete);
    setOpenAppoint(-1);
    setAppointToDelete(item);
  };

  const handleViewProfile = (patient_id, program_id) => {
    localStorage.setItem("from_dash", true);
    navigate("/patient-details/" + patient_id + "/" + program_id);
  };

  //const [totalAppoint, setTotalAppoint] = useState(0);
  const [succPopUp, setSuccPopUp] = useState("");
  const SuccopupRef = useRef(succPopUp);
  useEffect(() => {
    SuccopupRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);

  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  const dltDismiss = (doConfirm) => {
    setContentAppointnentsLoaded(false);
    if (doConfirm) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "appointments/deleteAppointment", {
          appointmentId: appointToDelete,
        })
        .then((res) => {
          if (res.data.responseData) {
            var userData = JSON.parse(localStorage.getItem("userData"));
            loadAppointments(userData);
            setSuccPopUp("Appointment is deleted Successfully!");
          }
        })
        .catch((error) => {
          console.error(error);
          setContentAppointnentsLoaded(true);
          setErrorPopUp(
            "User or Appointment does not exist, Please Try again!"
          );
        });
    } else {
      setContentAppointnentsLoaded(true);
    }
    setOpenDelete(false);
  };

  const loadAppointments = (userData) => {
    axios.defaults.headers.common["Authorization"] = userData.token;
    axios
      .post(window.ajaxLink + "cloud_dashboard/my-appointments", {})
      .then((res) => {
        if (res.data.responseData) {
          var datesAppointments = [];
          let appointmentRes = res.data.responseData.filter(
            (item) =>
              moment(item.end_time).format() > moment(new Date()).format()
          );
          props.checkLoggedIn(true);
          setContentAppointnentsLoaded(true);
          function createDates(i) {
            if (i < 30) {
              let dateCount = new Date();
              let dateCountString = dateCount.setDate(dateCount.getDate() + i);
              dateCountString = new Date(dateCountString).toISOString();
              dateCountString = moment(dateCountString).format();
              dateCountString = dateCountString.split("T")[0];

              datesAppointments.push({
                date: dateCountString,
                appointments: [],
              });
              createDates(i + 1);
            }
          }
          createDates(0);

          var index = 0;
          function processAppointments() {
            var singleAppointment = appointmentRes[index];
            if (singleAppointment) {
              var appointTime = moment(singleAppointment.schedule_date)
                .format()
                .split("T")[0];
              function findDateAndPush(dayy) {
                if (dayy.date === appointTime) {
                  dayy.appointments.push(singleAppointment);
                }
              }
              datesAppointments.forEach(findDateAndPush);
              index++;
              processAppointments();
            }
          }
          processAppointments();

          setAppointments(datesAppointments);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
          props.checkLoggedIn(false);
        }
      });
  };

  useEffect(() => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      loadAppointments(userData);
    }
    // eslint-disable-next-line
  }, []);

  const [isAnswersOpen, setAnswersOpen] = useState(false);
  const [answersLoaded, setAnswersLoaded] = useState(false);
  const [answersInfo, setAnswersInfo] = useState([]);
  const openCloseAnswers = (patient_id) => {
    if (!isAnswersOpen) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/patient-answers", {
          id: patient_id,
        })
        .then((res) => {
          if (res.data.responseData) {
            setAnswersInfo(res.data.responseData);
            setAnswersLoaded(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setAnswersInfo([]);
      setAnswersLoaded(false);
    }
    setAnswersOpen(!isAnswersOpen);
  };

  return (
    <div className="appointments_hold">
      <div
        className="dash_box_title"
        // style={{
        //   position: "sticky",
        //   top: 0,
        //   left: 0,
        //   right: 0,
        //   background: "#fff",
        //   textAlign: "center",
        //   zIndex: 99,
        //   flex: 1,
        //   width: '100%'
        // }}
      >
        My Appointments
      </div>
      <div ref={holdAppScroll} className="dash_appointments">
        {contentAppointnentsLoaded && appointments && appointments.length > 0 ? (
          appointments.map((item, i) => (
            <div key={i + "a"}>
              {item.date === moment(new Date()).format().split("T")[0] ? (
                <div className="appointment_date">
                  {"Today, " + moment(item.date).format("LL")}
                </div>
              ) : (
                <div className="appointment_date">
                  {moment(item.date).format("LL")}
                </div>
              )}
              <>
                {item.appointments && item.appointments.length > 0 ? (
                  item.appointments.map((itemApp, j) => (
                    <div
                      key={j + "b"}
                      className={
                        "appointment_container" +
                        (appointOpen === itemApp.appointment_id
                          ? " appoint_contain_active"
                          : "")
                      }
                      ref={(element) => {
                        appointRef.current[itemApp.appointment_id] = element;
                      }}
                    >
                      {/*<div
                      className={
                        "appointment_handle" +
                        (card.pain_level ? " ap_color" + Math.round(card.pain_level / 2) * 2 : "")
                      }
                    ></div>*/}
                      <div
                        onClick={(e) =>
                          openSingleAppoint(itemApp.appointment_id, e)
                        }
                        ref={wrapperRef}
                        style={{
                          pointerEvents: appointOpen !== -1 ? "none" : "auto",
                        }}
                        className="appointment_details"
                      >
                        <div className="a_details_side">
                          <div className="pain_status_appointment">
                            <div
                              className={
                                "ad_pain_dot" +
                                (itemApp.pain_level <= 3
                                  ? " pain_color_green"
                                  : itemApp.pain_level > 3 &&
                                    itemApp.pain_level <= 6
                                  ? " pain_color_yellow"
                                  : itemApp.pain_level > 6 &&
                                    itemApp.pain_level <= 10
                                  ? " pain_color_red"
                                  : "")
                              }
                            ></div>
                          </div>
                          <div className="appointee_name">
                            {itemApp.username}
                          </div>
                          <div className="appointment_new">New</div>
                          <div className="appointment_time">
                            {moment(itemApp.start_time).format("LT")}-
                            {moment(itemApp.end_time).format("LT")}
                          </div>
                          {/*<div className="appointment_pain_title">{card.pain_type}</div>*/}
                          {/*<div className="appointment_question_image">
                          <div className="dash_tooltip_hold">
                            <div className="dash_tooltip">
                              <div className="dash_tooltip_text">View Questionnaire</div>
                            </div>
                            <div className="dash_arrow"></div>
                          </div>
                    </div>*/}
                          <div className="appointment_problem">
                            {itemApp.problem_name}
                            {" | "}
                            {itemApp.sub_problem_name}
                          </div>
                          <div className="appointment_problem">
                            {itemApp.pain_level <= 2
                              ? "Mild Pain"
                              : itemApp.pain_level > 2 &&
                                itemApp.pain_level <= 4
                              ? "Moderate Pain"
                              : itemApp.pain_level > 4 &&
                                itemApp.pain_level <= 6
                              ? "Severe Pain"
                              : itemApp.pain_level > 6 &&
                                itemApp.pain_level <= 8
                              ? "Most Severe Pain"
                              : itemApp.pain_level > 8 &&
                                itemApp.pain_level <= 10
                              ? "Unbearable Pain"
                              : ""}
                            {" on "}
                            {moment(itemApp.schedule_date).format("L")}
                          </div>
                          {/* <div className="appointment_problem">Set last active</div> */}
                        </div>
                        <div
                          className="a_videocall_side" /* onClick={(e) => openSingleAppoint(itemApp.appointment_id, e)} */
                        >
                          <div
                            style={{ pointerEvents: "auto" }}
                            className={
                              moment(itemApp.join_time).format() <
                              moment(new Date()).format()
                                ? "appointment_call_btn"
                                : ""
                            }
                            onClick={(e) =>
                              launchAppointment(itemApp.appointment_id, e)
                            }
                          >
                            <div className="dash_tooltip_hold_app">
                              <div className="dash_tooltip_app">
                                <div className="dash_tooltip_text_app">
                                  Join Call
                                </div>
                              </div>
                              <div className="dash_arrow_app"></div>
                            </div>
                          </div>
                        </div>
                        {!isAnswersOpen && (
                          <div
                            style={{ pointerEvents: "auto" }}
                            className="appointment_more"
                          >
                            <div
                              className={
                                i > appointments.length - 1
                                  ? "appointment_more_container"
                                  : "appointment_more_container_last"
                              }
                            >
                              <div
                                className="appointment_more_menu"
                                style={{
                                  pointerEvents:
                                    moment(itemApp.join_time).format() >=
                                    moment(new Date()).format()
                                      ? "auto"
                                      : "none",
                                }}
                                onClick={(e) =>
                                  openCloseDelete(itemApp.appointment_id, e)
                                }
                              >
                                Cancel Appointment
                              </div>

                              <div
                                onClick={() =>
                                  handleViewProfile(
                                    itemApp.patient_id,
                                    itemApp.program_id
                                  )
                                }
                                className="appointment_more_menu"
                              >
                                View Patient Profile
                              </div>

                              <div
                                className="appointment_more_menu"
                                onClick={() =>
                                  openCloseAnswers(itemApp.patient_id)
                                }
                              >
                                View Questionnaire
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {appointOpen === itemApp.appointment_id && (
                        <div onMouseDown={(e) => e.stopPropagation()}>
                          <AppointmentCard
                            closeAppoint={openSingleAppoint}
                            openCloseDelete={openCloseDelete}
                            appointId={itemApp.appointment_id}
                            appointOpen={appointOpen}
                            cardData={itemApp}
                            cardDate={itemApp.schedule_date}
                          />
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="appointment_details_empty">
                    0 appointments scheduled
                  </div>
                )}
              </>
            </div>
          ))
        ) : !contentAppointnentsLoaded ? (
          <div className="p_load"></div>
        ) : (
          ""
        )}
      </div>
      {isOpenDelete && (
        <div className="dlt_wrapper">
          <div className="dbl_place_on_page">
            <Delete dltDismiss={dltDismiss} isAppointment={true} />
          </div>
        </div>
      )}
      {errorPopUp && (
        <div className="prog_err_hold ">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text ">{errorPopUp}</div>
        </div>
      )}
      {succPopUp && (
        <div className="prog_err_hold prog_pop_pat_correct">
          <div className="prog_pop_icon_correct prog_err_icon"></div>
          <div className="prog_err_text prog_pop_text_correct">{succPopUp}</div>
        </div>
      )}
      {isAnswersOpen && (
        <PatientAnswers
          // pageHeight={patPage.scrollHeight + 320 + "px"}
          answersLoaded={answersLoaded}
          answersInfo={answersInfo}
          openCloseAnswers={openCloseAnswers}
        />
      )}
    </div>
  );
};

export default Appointments;
